import React, { Component } from "react";
import { connect } from "react-redux";
import { View, ScrollView } from "react-native"
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faTimes, faChevronRight, faMinus } from "@fortawesome/free-solid-svg-icons"
import { newConversation, createGroup } from "../../../action";
import styles from "../../../styles";
import { action, colors } from "../../../const";
import Groplist from "../../../components/List/Groplist";
import PrimaryTitle from "../../../components/labels/PrimaryTitle";
import Button from "../../../components/form/Button";
import TextInput from "../../../components/form/TextInput";
import Header from "../../../components/Header";
import localize from "../../../localize";

class CreateGroup extends Component {

    ConversationList = [];

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selectedMember: [],
            member: [],
            searchString: "",
        }
    }

    async componentDidMount() {
        let data = this.props.groups;
        if (!data) {
            this.props.isLoading(true);
            data = await this.props.newConversation();
        }
        this.props.isLoading(false);
        this.ConversationList = data;
        return this.setState({ data });
    }

    onFamilySelected = (request) => {
        let { selected } = this.state;
        selected.push(request);
        return this.setState({ selected });
    }

    onHandleSearch = (searchString) => {
        const data = this.ConversationList.filter(e =>
            Object.values(e)
                .join(" ")
                .toLowerCase()
                .match(searchString.toLowerCase())
        )
        return this.setState({ data, searchString })
    }

    onCreateFamilyGroup = (member) => {
        let { selectedMember, data } = this.state;
        selectedMember.push(member);
        data = data.filter((item) => item !== member);
        this.setState({ selectedMember, data });
    }

    onRemoveFamilyMember = (member) => {
        let { selectedMember, data } = this.state;
        selectedMember = selectedMember.filter((item) => item !== member);
        data.push(member);
        return this.setState({ selectedMember, data });
    }

    createGroup = async () => {
        try {
            this.props.isLoading(true);
            const { id } = this.props.userInfo;
            let user_ids = '', family_ids = '';
            this.state.selectedMember.map((item) => {
                if (item.kind === 2) return user_ids += ',' + item.id
                if (item.kind === 1) return family_ids = item.family_id
                return 0;
            })
            user_ids += ',' + id;
            user_ids = user_ids.substring(1);
            let result = await this.props.createGroup(this, user_ids, family_ids);
            if (result.id && result.group_name) {
                this.props.history.push({
                    pathname: "/chat/conversation",
                    state: { groupId: result.id, name: result.group_name },
                    search: `?groupId=${result.id}&name=${result.group_name}`
                });
            }
            this.props.isLoading(false);
            return this.setState({
                data: this.ConversationList,
                selectedMember: [],
                member: [],
                searchString: ""
            });
        } catch (error) {
            console.log('createGroup', error);
        }
    }

    renderList = (item, index) => {
        return (
            <Groplist
                data={item}
                key={String(index)}
                onPress={() => this.onCreateFamilyGroup(item)}
            />
        )
    }

    renderSelectedList = (item, index) => {
        return (
            <Groplist
                data={item}
                key={String(index)}
                onPress={() => this.onRemoveFamilyMember(item)}
                rightIcon={this.state.selectedMember.length === 1 ? faChevronRight : faMinus}
            />
        )
    }

    renderInputSearch = () => {
        const { searchString } = this.state;
        return (
            <View style={{ padding: 10 }}>
                <TextInput
                    placeholder={localize.team_name_or_user}
                    value={searchString}
                    onChangeText={this.onHandleSearch}
                />
            </View>
        )
    }

    render() {
        const { data, selectedMember } = this.state;
        return (
            <View style={styles.container}>
                <Header
                    title={localize.New_Conversation}
                    right={
                        <Icon
                            icon={faTimes}
                            color={colors.white}
                            style={{ position: "static", fontSize: 20, marginRight: 15 }}
                            onClick={() => this.props.history.goBack()}
                        />
                    }
                />

                <ScrollView
                    contentInsetAdjustmentBehavior
                    style={{ height: this.props.height - 130 }}
                >
                    {this.renderInputSearch()}
                    <View style={styles.divider} />
                    {
                        selectedMember.length > 0 ?
                            <View>
                                {selectedMember.map((item, index) => this.renderSelectedList(item, index))}
                                <View style={{ alignItems: "center", backgroundColor: '#fff', paddingVertical: 20 }}>
                                    <View style={{ paddingBottom: 10, paddingHorizontal: 40, width: '100%' }}>
                                        <Button
                                            title={localize.START_CHATTING}
                                            size="small"
                                            onPress={this.createGroup}
                                        />
                                    </View>
                                    <View style={{ paddingHorizontal: 40 }}>
                                        {
                                            data.length === 0 ?
                                                <PrimaryTitle align="center" size={16}>
                                                    {localize.No_one_else_to_add}
                                                </PrimaryTitle>
                                                :
                                                <View>
                                                    <PrimaryTitle align="center" size={13}>
                                                        {localize.Or}
                                                    </PrimaryTitle>
                                                    <PrimaryTitle align="center" size={16}>
                                                        {localize.add_some_more_people_to_the_conversation}
                                                    </PrimaryTitle>
                                                </View>
                                        }
                                    </View>
                                </View>
                                <View style={[{ height: 1, width: '100%' }, styles.bglightGray]} />
                                {data.map((item, index) => this.renderList(item, index))}
                            </View>
                            :
                            data.map((item, index) => this.renderList(item, index))
                    }
                </ScrollView>
            </View>
        )
    }
}

const mapStateToProps = ({ setting, auth, chat }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo,
        groups: chat.newConversation
    };
}
const mapDispatch = (dispatch) => {
    return {
        newConversation: () => dispatch(newConversation()),
        createGroup: (obj, user_ids, family_ids) => dispatch(createGroup(obj, user_ids, family_ids)),
        isLoading: (status) => dispatch({ type: status ? action.LOADING_DIALOG_TRUE : action.LOADING_DIALOG_FALSE }),
    }
}
export default connect(mapStateToProps, mapDispatch)(CreateGroup);